import { BaseApiClient } from '../client'
import type { DashboardData, WebhookLog } from '../types'

export class DashboardApi extends BaseApiClient {
  async get(filters?: { startDate?: string; endDate?: string; campaignId?: string }) {
    const params = new URLSearchParams()
    if (filters?.startDate) params.append('startDate', filters.startDate)
    if (filters?.endDate) params.append('endDate', filters.endDate)
    if (filters?.campaignId) params.append('campaignId', filters.campaignId)

    const queryString = params.toString()
    return this.request<DashboardData>(
      `/api/admin/dashboard${queryString ? `?${queryString}` : ''}`
    )
  }

  async getWebhookLogs(limit = 50) {
    return this.request<WebhookLog[]>(`/api/admin/webhook-logs?limit=${limit}`)
  }
}
